import { CardDefinitionDtoToEntity } from "src/app/features/CardImplementation/subFeatures/CardDefinition/services/mappers/CardDefinitionDtoToEntity";
import type { CardDefinitionDto } from "src/app/features/CardImplementation/subFeatures/CardDefinition/types/CardDefinitionDto";
import type { CardDefinitionEntity } from "src/app/features/CardImplementation/subFeatures/CardDefinition/types/CardDefinitionEntity";
import type { ResourcePageDto } from "../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const CardDefinitionTableDtoMapper = (
    input: Readonly<ResourcePageDto<CardDefinitionDto>>,
): ResourcePageEntity<CardDefinitionEntity> => {
    return {
        list: input.list ? input.list.map(CardDefinitionDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
